<div class="container-fluid mt-2">
  <div class="row faixa-conteudo pt0">
    <div class="col col-lg-12">
      <div class="caixa">
        <div class="conteudo-caixa-sem-titulo sem-padding">
          <div class="filtro-dash">
            <div>
              <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                Dealer
              </div>

              <span class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtrosDealers.selecionados()"
                style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                {{dealer.nome}}
                <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
              </span>
              <div class="botao">
                <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                  <em class="fa fa-plus"></em>
                </button>
              </div>
              <div class="clear"></div>
            </div>
          </div>
          <hr>
          <div class="p-grid p-ai-center p-mb-3">
            <div class="p-col-12 p-md-4 p-p-1">
              <div class="filtro ng-star-inserted" translate>
                Data Inicial
              </div>
              <p-calendar [(ngModel)]="dataInicial" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                styleClass="p-inputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true" [monthNavigator]="true"
                (onClearClick)="limpaDataInicial()" yearRange="2000:2030" placeholder="Data Inicial"
                showButtonBar="true">
              </p-calendar>
            </div>

            <div class="p-col-12 p-md-4 p-p-1">
              <div class="filtro ng-star-inserted" translate>
                Data Final
              </div>
              <p-calendar [(ngModel)]="dataFinal" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                styleClass="p-inputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true" [monthNavigator]="true"
                (onClearClick)="limpaDataFinal()" yearRange="2000:2030" placeholder="Data Final" showButtonBar="true">
              </p-calendar>
            </div>

            <div class="p-col-12 p-md-4 p-p-1">
              <div class="p-d-flex p-jc-start p-ai-center p-flex-wrap gap-2">
                <button type="button" class="btn btn-primary margin-buttons mr-2" (click)="filtroAPI()">
                  Filtrar <i class="fas fa-search"></i>
                </button>
                <button type="button" class="btn margin-buttons" [class.btn-info]="!getListagemComFiltros()"
                  [class.btn-warning]="getListagemComFiltros()" (click)="exibirFiltro()">
                  Mais Filtros <em class="fa fa-filter"></em>
                </button>

              </div>
            </div>
          </div>

          <hr>
        </div>
      </div>
    </div>
  </div>

  <div class="p-d-flex p-jc-center" *ngIf="loading">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div class="p-grid mt-1" *ngIf="!loading">
    <div class="p-col-12 p-md-4 p-pt-0">
      <app-resumo-leads *ngIf="leadData" [totalInsucesso]="totalInsucesso" [leadData]="leadData" [insucessoLeads]="insucessoLeads"></app-resumo-leads>
    </div>
    <div class="p-col-12 p-md-8 p-pt-0">
      <div class="container-graficos p-mt-3">
        <app-primeiro-contato *ngIf="primeiroContato" [primeiroContato]="primeiroContato" [filtro]="form.value"></app-primeiro-contato>
      </div>

      <div class="container-graficos">
        <app-status-contato-ativo *ngIf="statusContatoAtivo" [grafico]="statusContatoAtivo">
        </app-status-contato-ativo>
      </div>
    </div>

    <div class="p-col-6 p-pt-0">
      <div class="container-graficos p-mt-3">
        <app-Insucesso-leads-qualificados *ngIf="insucesso" [insucesso]="insucesso"></app-Insucesso-leads-qualificados>
      </div>
    </div>
    <div class="p-col-6 p-pt-0">
      <div class="container-graficos p-mt-3">
        <app-fluxo-conversao *ngIf="funilConversao" [dados]="funilConversao"></app-fluxo-conversao>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Definir filtros" [(visible)]="displayFiltros" [style]="{width: '550px'}" [modal]="true"
  [draggable]="false">
  <form [formGroup]="form">
    <div class="container striped-rows">
      <!-- <div class="row ptb5">
        <div translate class="col col-4">
          Grupo Econômico
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body" placeholder="Selecione um grupo econômico" [options]="gruposEconomicos"
            optionLabel="descricao" optionValue="id" formControlName="grupo_economico" [style]="{'minWidth':'100%'}"
            styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div> -->
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.leads.filtros.modeloVeic'}}
        </div>
        <div class="col col-8">
          <input type="text" class="p-inputtext p-inputtext-sm"
            [placeholder]="'relatorioVeiculos.leads.filtros.modeloVeicPlaceHolder' | translate"
            formControlName="modelo_veic" style="min-width: 100%;" />
        </div>
      </div>
      
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.leads.filtros.versaoVeic'}}
        </div>
        <div class="col col-8">
          <input type="text" class="p-inputtext p-inputtext-sm"
            [placeholder]="'relatorioVeiculos.leads.filtros.versaoVeicPlaceHolder' | translate"
            formControlName="versao_veic" style="min-width: 100%;" />
        </div>
      </div> 

      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.leads.filtros.nomeVendedor'}}
        </div>
        <div class="col col-8">
          <input type="text" class="p-inputtext p-inputtext-sm"
            [placeholder]="'relatorioVeiculos.leads.filtros.nomeVendedorPlaceHolder' | translate"
            formControlName="nome_vendedor" style="min-width: 100%;" />
        </div>
      </div> 
      
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.leads.filtros.somenteFabrica'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'relatorioVeiculos.veiculoEstoque.filtros.vendaPlaceHolder' | translate}}"
            [options]="somenteFab" optionLabel="nome" optionValue="valor" formControlName="somente_fabrica"
            [autoDisplayFirst]="false" [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>

      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.leads.filtros.grupoEconomico'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'relatorioVeiculos.veiculoEstoque.filtros.vendaPlaceHolder' | translate}}"
            [options]="gruposEconomicos" optionLabel="descricao" optionValue="id" formControlName="grupo_economico"
            [autoDisplayFirst]="false" [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>

      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.leads.filtros.regionalFiltro'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
          placeholder="{{'relatorioVeiculos.veiculoEstoque.filtros.vendaPlaceHolder' | translate}}"
          [options]="regionais" optionLabel="descricao" optionValue="id" formControlName="id_regional"
          [autoDisplayFirst]="false" [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
    <button translate type="button" class="btn btn-info" (click)="filtroAPI()">Filtrar</button>
  </ng-template>
</p-dialog>

<!-- <p-dialog header="Selecione Dealers" [(visible)]="displayFiltrosDealers" [style]="{width: '800px'}" [modal]="true"
  [draggable]="false">
  <div class="d-flex flex-wrap">
    <ng-container *ngFor="let item of filtrosDealers.naoSelecionados()">
      <span class="btn btn-primary btn-sm itemListaSelecao" style="font-size: 14px; margin: 2px;"
        (click)="onAdicionarDealerFiltro(item)">
        {{item.toTexto()}}
      </span>
    </ng-container>
  </div>
</p-dialog> -->

<!-- Componente modular para filtro de dealers -->
<app-filtro-dealers
  [(visible)]="displayFiltrosDealers"
  [dealers]="filtrosDealers.dealers"
  [headerTitle]="'relatorioVeiculos.controleProposta.selecioneDealers'"
  [filterPlaceholder]="'relatorioVeiculos.controlePedidos.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>